var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-wrap"},[_c('p',[_vm._v("© 2026 阆中分类信息网 版权所有 | "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("蜀ICP备2026028209号")])])])])
}]

export { render, staticRenderFns }